<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Services Details</h2>
            <ul>
                <li>
                    <a href="index.html">Home</a>
                </li>
                <li>Services Details</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>Creative Solutions, Creative Results</h3>
                    <p>Lorem ipsum dolor sit amet, consectetLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <h3>Solving Problems, Building Brands</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> Offering All Jobs Guaranteed & Neatly Done</li>
                                    <li><i class="flaticon-check"></i> The Problem</li>
                                    <li><i class="flaticon-check"></i> Dedicated and Knowledgeable Professionals</li>
                                    <li><i class="flaticon-check"></i> The Skills</li>
                                    <li><i class="flaticon-check"></i> We provide 24/7 on Time Services</li>
                                    <li><i class="flaticon-check"></i> We Use Technology To Do The Job More Quickly</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="text-result">
                        <h3>Challenge and Solutions</h3>
                        <p>Surrounded by their possessions, pets, and a familiar environment, our clients receive the support they ned to enjoy their regular activities and continue living well at home.</p>
                    </div>

                    <div class="services-details-faq">
                        <ul class="accordion">
                            <li class="accordion-item">
                                <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-plus'></i> What is digital marketing?</a>
                                <p class="accordion-content">Digital marketing involves marketing to people using Internet-connected electronic devices, namely computers, smartphones and tablets. Digital marketing focuses on channels such as search engines, social media, email, websites and apps to connect with prospects and customers.</p>
                            </li>
                            
                            <li class="accordion-item">
                                <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-plus'></i> Would my business benefit from digital marketing?</a>
                                <p class="accordion-content">Digital marketing involves marketing to people using Internet-connected electronic devices, namely computers, smartphones and tablets. Digital marketing focuses on channels such as search engines, social media, email, websites and apps to connect with prospects and customers.</p>
                            </li>
    
                            <li class="accordion-item">
                                <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-plus'></i> What’s the biggest mistake digital marketers make?</a>
                                <p class="accordion-content">Digital marketing involves marketing to people using Internet-connected electronic devices, namely computers, smartphones and tablets. Digital marketing focuses on channels such as search engines, social media, email, websites and apps to connect with prospects and customers.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/services-details" class="active">Creative Web Design</a></li>
                        <li><a routerLink="/services-details">Complex Dashboard</a></li>
                        <li><a routerLink="/services-details">Digital Agency</a></li>
                        <li><a routerLink="/services-details">Software Engineers</a></li>
                        <li><a routerLink="/services-details">Marketing Agency</a></li>
                        <li><a routerLink="/services-details">Data Analysis</a></li>
                        <li><a routerLink="/services-details">App Development</a></li>
                        <li><a routerLink="/services-details">Web Application</a></li>
                        <li><a routerLink="/services-details">Logo & Branding</a></li>
                    </ul>

                    <div class="download-file">
                        <h3>Brochures</h3>

                        <ul>
                            <li><a routerLink="/services-details">PDF Download <i class='bx bxs-file-pdf'></i></a></li>
                            <li><a routerLink="/services-details">Services Details.txt <i class='bx bxs-file-txt'></i></a></li>
                        </ul>
                    </div>

                    <div class="services-contact-info">
                        <h3>Contact Info</h3>
                        
                        <ul>
                            <li>
                                <div class="icon">
                                    <i class='bx bx-user-pin'></i>
                                </div>
                                <span>Phone:</span>
                                <a href="tel:+21453545413">+2145 354 5413</a>
                            </li>
                            <li>
                                <div class="icon">
                                    <i class='bx bx-map'></i>
                                </div>
                                <span>Location:</span>
                                New York, USA
                            </li>
                            <li>
                                <div class="icon">
                                    <i class='bx bx-envelope'></i>
                                </div>
                                <span>Email:</span>
                                <a href="mailto:hello@rainz.com">hello@rainz.com</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/services-details">
                            <img src="assets/img/services/services-7.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a routerLink="/services-details">Creative Web Design</a></h3>
                        <span>Web Design</span>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/services-details">
                            <img src="assets/img/services/services-8.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a routerLink="/services-details">Digital Agency</a></h3>
                        <span>Agency</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/services-details">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a routerLink="/services-details">Complex Dashboard</a></h3>
                        <span>Solutions</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->